import AxiosInstance from "./api";

export const GeneralJournalService = {
  create: async (payload) => {
    return await AxiosInstance.post("/private/general-journal", payload);
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/general-journal/${id}`);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/general-journal/${id}`);
  },
  getS01DnBook: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/s01-dn", { params: query });
  },
  getS01DnRecords: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/s01-dn/records", {
      params: query,
    });
  },
  getS01DnRecordById: async (id) => {
    return await AxiosInstance.get(`/private/general-journal/book/s01-dn/records/${id}`);
  },
  deleteS01DnRecord: async (id) => {
    return await AxiosInstance.delete(`/private/general-journal/book/s01-dn/records/${id}`);
  },
  previewS01Dn: async (query) => {
    return await AxiosInstance.post("/private/general-journal/book/s01-dn/preview", null, {
      params: query,
    });
  },
  createS01Dn: async (query) => {
    return await AxiosInstance.post("/private/general-journal/book/s01-dn/create", null, {
      params: query,
    });
  },
  getJournalBook: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/list", { params: query });
  },
  getCashReceiptJournalAccounts: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/cash-receipts/accounts", {
      params: query,
    });
  },
  getCashReceiptJournal: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/cash-receipts", {
      params: query,
    });
  },
  getCashPaymentJournalAccounts: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/cash-payments/accounts", {
      params: query,
    });
  },
  getCashPaymentJournal: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/cash-payments", {
      params: query,
    });
  },
  getPurchasesJournalAccounts: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/purchases/accounts", {
      params: query,
    });
  },
  getPurchasesJournal: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/purchases", {
      params: query,
    });
  },
  getSalesJournalAccounts: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/sales/accounts", {
      params: query,
    });
  },
  getSalesJournal: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/sales", {
      params: query,
    });
  },
  getLedgerJournalAccounts: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/ledger/accounts", {
      params: query,
    });
  },
  getLedgerJournal: async (query) => {
    return await AxiosInstance.get("/private/general-journal/book/ledger", {
      params: query,
    });
  },
  syncAppendix1: async (query) => {
    try {
      return await AxiosInstance.post("/private/general-journal/sync/appendix-1", null, {
        params: query,
      });
    } catch (error) {
      if (error?.response?.status !== 404) {
        throw error;
      }
      // Fallback for older BE route variants.
      return await AxiosInstance.post("/private/general-journal/sync/appendix1", null, {
        params: query,
      });
    }
  },
};
